import config from "@/config";
import { requests } from ".";

const OPPORTUNITIES_SERVER_URL = config?.OPPORTUNITY_SERVER_URL;

export const OpportunityServices = {
  getPipelines: (locationId: string) =>
    requests(OPPORTUNITIES_SERVER_URL).get(`/opportunities/pipelines?locationId=${locationId}`),
};
